import React from 'react';
import '../../styles/common.css';
import styles from './Terms.module.css';
import Contacts from '../Contacts/Contacts';

const Terms = () => {
  const sections = [
    {
      id: 1,
      title: '1. Термины и определения',
      items: [
        {
          number: '1.1',
          text: 'Сайт — интернет-сайт, размещённый по сетевому адресу https://interworld.fun/ (включая любой его поддомен), представляющий собой организованную совокупность связанных между собой программ для ЭВМ, текстов, графических изображений, фото- и видеоматериалов и иных объектов интеллектуальных прав.'
        },
        {
          number: '1.2',
          text: 'Пользователь — любое лицо, использующее Сайт любым способом, включая, помимо прочего: просмотр материалов на Сайте и иные действия, доступные в рамках функционала Сайта.'
        },
        {
          number: '1.3',
          text: 'Администрация — Самозанятый Сопов Артем Игоревич (плательщик налога на профессиональный доход), являющийся обладателем прав на Сайт и/или законным администратором Сайта. Реквизиты и контактные данные указаны в разделе 9 настоящего Соглашения.'
        },
        {
          number: '1.4',
          text: 'Платные услуги — цифровые услуги и внутриигровая валюта, реализуемые на серверах проекта Interworld в игре Hytale. Порядок приобретения данных услуг и валюты не регулируется данным Соглашением, а устанавливается отдельным документом — «Публичной офертой на оказание цифровых услуг».'
        },
        {
          number: '1.5',
          text: 'Игровой сервер — программно-аппаратный комплекс проекта Interworld, доступ к которому осуществляется через клиент игры Hytale по сетевому адресу play.interworld.fun (включая любые его поддомены). Порядок доступа, нахождения и взаимодействия пользователей на Игровом сервере не является предметом настоящего Соглашения и регулируется отдельным документом — «Сводом правил сервера Interworld».'
        },
        {
          number: '1.6',
          text: 'Стороны — Пользователь и Администрация при совместном упоминании. Термины, не определённые в настоящем разделе, толкуются в соответствии с текстом Соглашения, а при отсутствии однозначного толкования — в соответствии с законодательством РФ.'
        }
      ]
    },
    {
      id: 2,
      title: '2. Общие положения',
      items: [
        {
          number: '2.1',
          text: 'Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения между Администрацией и Пользователями Сайта, складывающиеся исключительно по поводу использования самого Сайта. Текст Соглашения постоянно размещён в сети Интернет по адресу https://interworld.fun/terms.'
        },
        {
          number: '2.2',
          text: 'Текст Соглашения устанавливает базовые правила использования функционала Сайта. В случае приобретения Пользователем платных цифровых услуг и внутриигровой валюты, финансовые и правовые отношения Сторон регулируются исключительно «Публичной офертой на оказание цифровых услуг», размещенной на Сайте.'
        },
        {
          number: '2.3',
          text: 'Продолжая использовать Сайт, Пользователь подтверждает, что ознакомился с действующей редакцией Соглашения и принял его условия. Если Пользователь не согласен с Соглашением или любым из его условий, он обязан прекратить использование Сайта.'
        }
      ]
    },
    {
      id: 3,
      title: '3. Назначение Сайта',
      items: [
        {
          number: '3.1',
          text: 'Сайт является онлайн-ресурсом, в рамках которого Пользователь получает возможность с помощью программно-аппаратных средств Сайта ознакомиться с описанием игровых серверов Interworld в игре Hytale, предлагаемыми цифровыми услугами, правилами проекта, а также осуществлять иные действия, доступные в рамках функционала Сайта.'
        }
      ]
    },
    {
      id: 4,
      title: '4. Общие условия использования и ограничения',
      items: [
        {
          number: '4.1',
          text: 'При использовании Сайта Пользователь обязуется соблюдать условия настоящего Соглашения и требования законодательства Российской Федерации.'
        },
        {
          number: '4.2',
          text: 'Несовершеннолетние Пользователи используют Сайт с согласия своих законных представителей (родителей, опекунов, попечителей) в случаях и в пределах, предусмотренных законодательством РФ.'
        },
        {
          number: '4.3',
          text: 'При использовании Сайта Пользователь не вправе: предпринимать попытки несанкционированного доступа к любой части или функциям Сайта либо к связанным с ним сетям; использовать алгоритмы, методы, устройства или процессы для несанкционированного доступа к информации, автоматизированного сбора данных (парсинга), копирования или отслеживания любой части Сайта, обхода его навигации; выдавать себя за другое лицо или представителя организации; размещать на Сайте информацию от имени третьих лиц без соответствующего согласия.'
        },
        {
          number: '4.4',
          text: 'Администрация вправе в любое время производить модификации программного обеспечения Сайта, останавливать его работу для профилактических работ, устранять неисправности и сбои, предотвращать несанкционированный доступ, обновлять материалы и т. п.'
        },
        {
          number: '4.5',
          text: 'Принимая условия Соглашения, Пользователь подтверждает согласие с правилами обработки данных, изложенными в разделе 7 настоящего Соглашения.'
        },
        {
          number: '4.6',
          text: 'Для сбора базовой статистики и обеспечения безопасности Администрация может сохранять информацию об IP-адресах Пользователя и использовать файлы технической информации (cookies) на устройстве Пользователя.'
        }
      ]
    },
    {
      id: 5,
      title: '5. Интеллектуальные права',
      items: [
        {
          number: '5.1',
          text: 'Администрация обладает необходимыми правами на объекты интеллектуальной собственности, размещённые на Сайте, и на сам Сайт. Использование указанных объектов осуществляется на законном основании.'
        },
        {
          number: '5.2',
          text: 'Используя Сайт, Пользователь не получает исключительных прав или лицензий на какие-либо материалы Сайта (включая логотипы, товарные знаки и иные объекты интеллектуальных прав), если иное прямо не указано Администрацией.'
        },
        {
          number: '5.3',
          text: 'Пользователь, считающий, что какая-либо часть Сайта нарушает его права, направляет Администрации обращение по электронной почте с указанием нарушенных прав и обстоятельств, подтверждающих их принадлежность, ссылки на спорный материал, даты обнаружения и своих контактных данных. По результатам рассмотрения Администрация вправе удалить спорный материал либо отказать в удовлетворении обращения при его необоснованности.'
        }
      ]
    },
    {
      id: 6,
      title: '6. Ответственность сторон',
      items: [
        {
          number: '6.1',
          text: 'Стороны несут ответственность за неисполнение или ненадлежащее исполнение своих обязательств в соответствии с действующим законодательством Российской Федерации.'
        },
        {
          number: '6.2',
          text: 'Администрация не несёт ответственности за невозможность использования Сайта по причинам, не зависящим от Администрации, включая технические неполадки на стороне третьих лиц, действия Пользователя или третьих лиц, а также обстоятельства непреодолимой силы.'
        },
        {
          number: '6.3',
          text: 'Администрация не отвечает за совместимость и исправность программного и аппаратного обеспечения Пользователя, а также за услуги связи и доступ к сети Интернет, которые Администрация Пользователю не предоставляет.'
        },
        {
          number: '6.4',
          text: 'Стороны освобождаются от ответственности за полное или частичное неисполнение обязательств при наступлении обстоятельств непреодолимой силы (стихийные бедствия, военные действия, эпидемии, решения органов власти, изменения законодательства и т. п.) на срок действия таких обстоятельств.'
        }
      ]
    },
    {
      id: 7,
      title: '7. Обработка персональных данных',
      items: [
        {
          number: '7.1',
          text: 'Администрация минимизирует сбор пользовательских данных. При использовании Сайта и оформлении услуг Пользователь предоставляет Администрации исключительно свой игровой никнейм.'
        },
        {
          number: '7.2',
          text: 'Администрация не осуществляет сбор, хранение и обработку адресов электронной почты, номеров телефонов или платежных реквизитов Пользователей. Вся обработка платежной информации и сопутствующих персональных данных при совершении транзакций осуществляется исключительно на стороне уполномоченного платежного сервиса (Robokassa).'
        },
        {
          number: '7.3',
          text: 'Передача предоставленного никнейма третьим лицам не осуществляется, за исключением случаев, прямо предусмотренных законодательством РФ.'
        }
      ]
    },
    {
      id: 8,
      title: '8. Срок действия, изменение и разрешение споров',
      items: [
        {
          number: '8.1',
          text: 'Соглашение вступает в силу с момента размещения его текста на Сайте и действует до момента отзыва Администрацией. Для Пользователя Соглашение вступает в силу с момента начала использования Сайта.'
        },
        {
          number: '8.2',
          text: 'Администрация вправе изменять условия Соглашения. Изменения вступают в силу с момента размещения новой редакции на Сайте, если иной срок не указан дополнительно. Пользователю рекомендуется самостоятельно отслеживать актуальность редакции Соглашения.'
        },
        {
          number: '8.3',
          text: 'Недействительность одного или нескольких положений Соглашения не влечёт недействительности Соглашения в целом.'
        },
        {
          number: '8.4',
          text: 'Все споры разрешаются путём переговоров. При недостижении согласия спор подлежит рассмотрению в суде в соответствии с законодательством Российской Федерации.'
        }
      ]
    },
    {
      id: 9,
      title: '9. Реквизиты Администрации',
      items: [
        {
          number: '',
          text: 'Самозанятый: Сопов Артем Игоревич\nИНН: 780737781518\nЭлектронная почта: support@interworld.fun'
        }
      ]
    }
  ];

  return (
    <main className={`container ${styles.terms}`}>
      <div className="container">
        <div style={{marginTop: '1rem'}}>
          <header className={styles.header}>
            <h1 className="title">Пользовательское соглашение</h1>
            <p className={styles.subtitle}>Правила пользования сайтом Interworld. Дата вступления в силу: 21 июля 2026 г.</p>
          </header>

          <div className={styles.sectionsContainer}>
            {sections.map((section) => (
              <div key={section.id} className={`glassCard ${styles.section}`}>
                <h2 className={styles.sectionTitle}>{section.title}</h2>
                <div className={styles.itemsList}>
                  {section.items.map((item, index) => (
                    <div key={index} className={styles.item}>
                      {item.number && (
                        <span className={styles.itemNumber}>{item.number}</span>
                      )}
                      <p className={styles.itemText}>{item.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className={styles.footer}>
            <p className={styles.updateDate}>Дата последнего обновления: 21 июля 2026 г.</p>
          </div>

          <div className={styles.contactsSection}>
            <Contacts />
          </div>

        </div>
      </div>
    </main>
  );
};

export default Terms;
